const { setVisible, onAdaReady } = require('./index');
const { undismissAda } = require('./dismiss-button');

let chatOpen = false;
let currentGreeting = '';
const chatChangedCallbacks = [];

const openChat = () => chatOpen || toggleChat();
const closeChat = () => !chatOpen || toggleChat();

const toggleChat = () => {
  if (!window || !window.adaEmbed) return false;

  undismissAda();
  setVisible(true);
  return window.adaEmbed.toggle();
};

const onChatOpened = (callback) => onChatChanged((isChatOpen, ...args) => isChatOpen && callback(isChatOpen, ...args));
const onChatClosed = (callback) => onChatChanged((isChatOpen, ...args) => !isChatOpen && callback(isChatOpen, ...args));

const onChatChanged = (callback) => {
  if (typeof callback === 'function') chatChangedCallbacks.push(callback);
};

const isChatOpen = () => chatOpen;

const chatChange = (chatState) => {
  chatOpen = !!chatState;

  if (chatOpen) {
    document.documentElement.classList.add('ada-chatbot-chat-open');
  } else {
    document.documentElement.classList.remove('ada-chatbot-chat-open');
  }

  chatChangedCallbacks.forEach(callback => callback(chatOpen, window.adaEmbed));

  return chatOpen;
};

const setGreeting = async (answerID) => {
  if (!window || !window.adaEmbed) return false;

  currentGreeting = answerID || '';
  await new Promise(res => onAdaReady(() => setTimeout(res, 500)));
  await window.adaEmbed.reset({ greeting: currentGreeting });

  return true;
};

module.exports = {
  openChat,
  closeChat,
  toggleChat,
  onChatOpened,
  onChatClosed,
  onChatChanged,
  isChatOpen,
  chatChange,
  setGreeting,
};
